import { httpBatchLink } from '@trpc/client';
import { createTRPCReact } from '@trpc/react-query';
import type { inferRouterOutputs } from '@trpc/server';

import type { AppRouter } from '../../../api/src/routers';

export const trpc = createTRPCReact<AppRouter>();

// Tipos inferidos de las respuestas del API (para tipar props y handlers
// sin duplicar interfaces): RouterOutputs['subscriptions']['list'], etc.
export type RouterOutputs = inferRouterOutputs<AppRouter>;

// Detectar la URL base automáticamente
const getApiUrl = () => {
  // Si VITE_API_URL está definida en build (p. ej. en Docker local), tiene prioridad
  const envApiUrl = import.meta.env.VITE_API_URL;
  if (envApiUrl) {
    return `${envApiUrl.replace(/\/$/, '')}/trpc`;
  }
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:4000/trpc';
    } else {
      // Extraer el dominio base (ej: suscri.net de app.suscri.net)
      const domainParts = hostname.split('.');
      if (domainParts.length > 2) {
        // Si es un subdominio, usar el dominio base
        const baseDomain = domainParts.slice(-2).join('.');
        return `https://api.${baseDomain}/trpc`;
      } else {
        // Si es el dominio base directamente
        return `https://api.${hostname}/trpc`;
      }
    }
  }
  return 'http://localhost:4000/trpc'; // fallback
};

export const trpcClient = trpc.createClient({
  links: [
    httpBatchLink({
      url: getApiUrl(),
      headers() {
        const token = localStorage.getItem('token');
        const headers: Record<string, string> = token
          ? { authorization: `Bearer ${token}` }
          : {};
        // Workspace activo (equipos M7): el backend solo lo aplica a los
        // routers de datos; el resto sigue operando sobre la cuenta propia.
        try {
          const ws = localStorage.getItem('suscri-workspace');
          if (ws) {
            const parsed = JSON.parse(ws) as { ownerId?: string };
            if (parsed.ownerId) headers['x-workspace-owner'] = parsed.ownerId;
          }
        } catch {
          /* sin workspace */
        }
        return headers;
      },
    }),
  ],
});
